import { Typography, Tooltip } from '@mui/material';
import React from 'react';
import PurchaseOrders from 'types/entities/PurchaseOrders';

const PurchaseOrderCell = React.memo((row: PurchaseOrders) => (
  <Tooltip arrow title={row.poref ?? ''}>
    <Typography noWrap variant="body2">
      {row?.poref}
    </Typography>
  </Tooltip>
));

export default PurchaseOrderCell;
